import axios from 'axios';

//let root = "http://localhost";
let root = window.location.protocol + "//" + window.location.host;
let authHeader = {
    headers: {
        'Authorization': "Bearer " +  sessionStorage.getItem('token'),
        'X-Buddycom-From': "web-frontend",
    }
}
export default {
    post(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.headers.timeout = 30000;
        return axios.post(root + '/v2/api' + path, json, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    postWith2FA(path, json) {
        let authTmpHeader = {
            headers: {
                'Authorization': "Bearer " +  sessionStorage.getItem('twoPhaseToken'),
                'X-Auth-Type': '2FA'
            }
        }
        let header = JSON.parse(JSON.stringify(authTmpHeader));
        header.headers.timeout = 20000;
        return axios.post(root + '/v2/api' + path, json, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    postWithFile(path, uploadFile, param) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.headers['content-type'] = 'multipart/form-data; charset="utf-8"';
        let formData = new FormData();
        if (uploadFile != null) {
            formData.append('uploadFile', uploadFile);
        }
        formData.append('requestParam', param);
        return axios.post(root + '/v2/api' + path, formData, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
    		    return;
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    downloadBlob(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.responseType = 'blob';
        return axios.post(root + '/v2/api/' + path, json, header )
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
		        switch(error.response.status) {
                    case 403:
                        window.location.href = './login.html';
                        break;
                    default:
            		    throw new Error("Server Error status=" + error.response.status);
            		    break;
                }
            }
        });
    },
    downloadBinaryFile(path) {
        return axios.get(path,  { responseType : 'blob' })
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
		        switch(error.response.status) {
                    case 403:
                        window.location.href = './login.html';
                        break;
                    default:
            		    throw new Error("Server Error status=" + error.response.status);
            		    break;
                }
            }
        });
    },
    postNoError(path, json) {
        return axios.post(root + '/v2/api' + path, json, authHeader )
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
                throw new Error("Server Error status=" + error.response.status);
            }
        });
    },
    // AIサーバーのベースURLを取得する。設定値は末尾スラッシュやスキーム無しの形でも保存され得るので、
    // ここで aiGet/aiPost にそのまま渡せる形に揃える
    async fetchAiServerBaseUrl() {
        const res = await this.post("/getaiserverurl", {});
        if (res.data.status !== 0) {
            throw new Error(`getaiserverurl failed status=${res.data.status}`);
        }
        return normalizeAiServerUrl(res.data.aiServerUrl);
    },
    aiGet(baseUrl, path, tenantId) {
        return axios.get(baseUrl + path, {
            headers: aiHeaders(tenantId),
            timeout: 30000,
        }).catch(aiErrorHandler);
    },
    aiPost(baseUrl, path, body, tenantId) {
        return axios.post(baseUrl + path, body, {
            headers: aiHeaders(tenantId),
            timeout: 30000,
        }).catch(aiErrorHandler);
    },
    // AIサーバーへの SSE ストリーミング POST。axios はブラウザで POST + SSE のストリーム読み出しに
    // 対応しないため fetch を使う。result/error イベントで解決/例外化し、alive(keep-alive) は無視する
    async aiSse(baseUrl, path, body, tenantId) {
        let response;
        try {
            response = await fetch(baseUrl + path, {
                method: 'POST',
                headers: aiHeaders(tenantId),
                body: JSON.stringify(body),
            });
        } catch (error) {
            throw new Error("Network Error");
        }
        if (!response.ok || !response.body) {
            throw new Error("Server Error status=" + response.status);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        // result/error イベントを見つけたら解決/例外化する。「alive」は無視して null を返す
        const consumeEvent = (rawEvent) => {
            const parsed = parseSseEvent(rawEvent);
            if (parsed.event === 'result') {
                return JSON.parse(parsed.data);
            }
            if (parsed.event === 'error') {
                const error = new Error("AI SSE error code=" + parsed.data);
                error.sseErrorCode = Number(parsed.data);
                throw error;
            }
            return undefined;
        };

        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            buffer += decoder.decode(value, { stream: true });
            // Ktor の SSE 実装は行末を CRLF("\r\n") で書き出す（HTTPの慣例通りだが、SSE仕様のLFのみとは異なる）。
            // "\n\n" 区切りで探すとイベント間の実際の区切りは "\r\n\r\n" になり "\n\n" を含まないため、
            // 正規化しておかないと全イベント（keep-alive含む）が1つに連結されたまま処理されてしまう。
            // チャンク境界で \r と \n が分かれて届く可能性があるため、連結済みの buffer 全体に対して行う
            buffer = buffer.replace(/\r\n/g, '\n');

            let sepIndex;
            while ((sepIndex = buffer.indexOf('\n\n')) >= 0) {
                const rawEvent = buffer.slice(0, sepIndex);
                buffer = buffer.slice(sepIndex + 2);
                const result = consumeEvent(rawEvent);
                if (result !== undefined) {
                    return result;
                }
            }
        }

        // サーバーが終端イベント送出の直後に接続を閉じ、末尾の空行(\n\n)が届かないまま
        // done になることがある。バッファに未処理の内容が残っていれば最後にもう一度試す
        const trailing = buffer.trim();
        if (trailing) {
            const result = consumeEvent(trailing);
            if (result !== undefined) {
                return result;
            }
        }
        throw new Error("AI SSE stream ended without a result");
    },

};

function normalizeAiServerUrl(rawUrl) {
    const trimmed = String(rawUrl || "").replace(/\/+$/, "");
    if (!trimmed) {
        throw new Error("empty ai server url");
    }
    if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
        return trimmed;
    }
    return `https://${trimmed}`;
}

function aiHeaders(tenantId) {
    return {
        'Authorization': "Bearer " + (sessionStorage.getItem('token') || ''),
        'X-TENANT-ID': String(tenantId),
        'Content-Type': 'application/json',
    };
}

function parseSseEvent(rawEvent) {
    let eventType = 'message';
    const dataLines = [];
    for (const line of rawEvent.split('\n')) {
        if (line.startsWith('event:')) {
            eventType = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trim());
        }
    }
    return { event: eventType, data: dataLines.join('\n') };
}

function aiErrorHandler(error) {
    if (error.message && error.message.indexOf("Network Error") >= 0) {
        throw new Error("Network Error");
    }
    if (error.message && error.message.indexOf("timeout") >= 0) {
        throw new Error("Timeout Error");
    }
    const status = error.response && error.response.status;
    if (status === 401 || status === 403) {
        window.location.href = './login.html';
    }
    throw error;
}

